import { render } from "./ReturnStock.vue?vue&type=template&id=61aaa797&scoped=true"
import script from "./ReturnStock.vue?vue&type=script&lang=js"
export * from "./ReturnStock.vue?vue&type=script&lang=js"

import "./ReturnStock.vue?vue&type=style&index=0&id=61aaa797&scoped=true&lang=css"
import "./ReturnStock.vue?vue&type=style&index=1&id=61aaa797&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aaa797"]])

export default __exports__